/* ATP Searchanise image fix (Jul 2026).
   Searchanise's product templates emit <img class="lazyload" data-src="...">
   with no src; the theme's CSS (img.lazyload:not([src]){opacity:0}) hides
   exactly that, and lazysizes doesn't process Searchanise-injected nodes.
   This watches Searchanise containers and promotes data-src -> src.
   Fully isolated: cannot affect theme scripts, galleries, or menus. */
(function () {
  'use strict';
  function fixImg(img) {
    try {
      if (!img.getAttribute('src') && img.getAttribute('data-src')) {
        img.setAttribute('src', img.getAttribute('data-src'));
        if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
        img.classList.add('lazyloaded');
      }
    } catch (e) {}
  }
  function sweep(root) {
    try {
      (root.querySelectorAll ? root : document)
        .querySelectorAll('[class*="snize"] img, [id*="snize"] img')
        .forEach(fixImg);
    } catch (e) {}
  }
  function init() {
    try {
      var s = document.createElement('style');
      s.textContent = '[class*="snize"] img.lazyloaded,[id*="snize"] img.lazyloaded{opacity:1 !important;}';
      document.head.appendChild(s);
      sweep(document);
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          for (var j = 0; j < muts[i].addedNodes.length; j++) {
            var n = muts[i].addedNodes[j];
            if (n.nodeType === 1) sweep(n.querySelectorAll ? n : document);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
